<template>
    <div>
        <v-row class="mb-4" style="border:solid 1px #e4e4e4;">
            <v-col
                v-for="item in studentFieldArray.topBlock"
                :key="`top-block-${item.fieldType}`"
                col="12"
                :md="item.fieldType==='enrollmentCode' ? 4 : 2"
                :lg="item.fieldType==='enrollmentCode' ? 4 : 2"
                :sm="item.fieldType==='enrollmentCode' ? 12 : 3"
            >
                <label class="font-weight-medium subtitle-2">{{ item.text }}</label>
                <v-text-field
                    v-if="item.fieldType === 'enrollmentCode'"
                    v-model="item.value"
                    :placeholder="item.text"
                    :disabled="item.disabled"
                    dense
                    outlined
                    hide-details
                    @blur="getStudentDetails(item)"
                />
                <v-text-field
                    v-else
                    v-model="item.value"
                    :placeholder="item.text"
                    :disabled="item.disabled"
                    dense
                    outlined
                    hide-details
                />
            </v-col>
        </v-row>
        <v-row style="border:solid 1px #e4e4e4;">
            <v-col
                v-for="item in studentFieldArray.bottomBlock"
                :key="`top-block-${item.fieldType}`"
                cols="12"
                :md="item.fieldType==='address' ? 12 : 3"
                :lg="item.fieldType==='address' ? 12 : 3"
                :sm="item.fieldType==='address' ? 12 : 3"
            >
                <label class="font-weight-medium subtitle-2">{{ item.text }}</label>
                <v-text-field
                    v-if="item.type==='textField'"
                    :value="item.value"
                    :placeholder="item.text"
                    :disabled="item.disabled"
                    dense
                    outlined
                    hide-details
                />
                <v-autocomplete
                    v-if="item.type==='dropdown' && item.fieldType !== 'studentKit'"
                    :value="item.value"
                    :placeholder="item.text"
                    :disabled="item.disabled"
                    :items="itemArrayList[item.fieldType]"
                    dense
                    outlined
                    hide-details
                />
                <v-autocomplete
                  v-if="item.type === 'dropdown' && item.fieldType === 'studentKit'"
                  v-model="item.value"
                  :placeholder="item.text"
                  :disabled="item.disabled"
                  :items="itemArrayList[item.fieldType]"
                  @change="getSelectedItem(item)"
                  dense
                  outlined
                  hide-details
                />
                <v-textarea
                    v-if="item.type==='textarea'"
                    :value="item.value"
                    :placeholder="item.text"
                    :disabled="item.disabled"
                    rows="1"
                    dense
                    outlined
                    hide-details
                />
            </v-col>
        </v-row>
    </div>
</template>
<script>
import constants from '@/utils/constants'
export default {
  name: 'StudentFormComponent',
  props: {
    enrollmentCode: {
      type: String,
      default: null
    },
    studentObj: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      studentFieldArray: {
        topBlock: [
          { text: 'Enrollment Code', fieldType: 'enrollmentCode', value: '', type: 'textField', disabled: false },
          { text: 'Franchise Name', fieldType: 'franchiseName', value: '', type: 'textField', disabled: false },
          { text: 'Academic Year', fieldType: 'academicYear', value: '', type: 'textField', disabled: false },
          { text: 'Class', fieldType: 'class', value: '', type: 'textField', disabled: false },
          { text: 'Section', fieldType: 'section', value: '', type: 'textField', disabled: false }
        ],
        bottomBlock: [
          { text: 'Student Name', fieldType: 'studentName', value: '', type: 'textField', disabled: false },
          { text: "Father's Name", fieldType: 'fatherName', value: '', type: 'textField', disabled: false },
          { text: "Mother's Name", fieldType: 'motherName', value: '', type: 'textField', disabled: false },
          { text: "Gaurdian's Name", fieldType: 'gaurdianName', value: '', type: 'textField', disabled: false },
          { text: 'Student DOB', fieldType: 'studentDob', value: '', type: 'textField', disabled: false },
          { text: "Father's Mobile", fieldType: 'fatherMob', value: '', type: 'textField', disabled: false },
          { text: "Mother's Mobile", fieldType: 'motherMob', value: '', type: 'textField', disabled: false },
          { text: "Gaurdian's Mobile", fieldType: 'gaurdianMob', value: '', type: 'textField', disabled: false },
          { text: 'Student Gender', fieldType: 'studentGender', value: '', type: 'textField', disabled: false },
          { text: "Father's Email", fieldType: 'fatherEmail', value: '', type: 'textField', disabled: false },
          { text: "Mother's Email", fieldType: 'motherEmail', value: '', type: 'textField', disabled: false },
          { text: "Gaurdian's Email", fieldType: 'gaurdianEmail', value: '', type: 'textField', disabled: false },
          { text: 'Student Kit Received By Parent', fieldType: 'studentKit', value: '', type: 'dropdown', disabled: false },
          { text: 'State', fieldType: 'state', value: '', type: 'textField', disabled: false },
          { text: 'City', fieldType: 'city', value: '', type: 'textField', disabled: false },
          { text: 'Pincode', fieldType: 'pincode', value: '', type: 'textField', disabled: false },
          { text: 'Address', fieldType: 'address', value: '', type: 'textarea', disabled: false }
        ]
      },
      itemArrayList: {
        studentKit: ['Yes', 'No']
      }
    }
  },
  async created () {
    if (this.enrollmentCode) {
      for (let item of this.studentFieldArray.topBlock) {
        if (item.fieldType === 'enrollmentCode') {
          item.value = this.enrollmentCode
          item.disabled = true
          await this.getStudentDetails(item)
        }
      }
    }
  },
  methods: {
    formatDate (dateInput) {
      if (!dateInput) return ''
      const date = new Date(dateInput)
      if (isNaN(date.getTime())) {
        return ''
      }
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    getStudentDetails: async function (obj) {
      try {
        if (!obj.value) {
          return false
        }
        let resp = await http.get(`${constants.API_URL}/api/v1/branch-transfer/get-student-details-by-enrollmentCode/${obj.value}`)
        if (resp.status === 200) {
          this.$emit('setStudentDetails', resp.data)
          this.$emit('setEnrollmentCode', obj.value)
          this.studentFieldArray.topBlock.forEach(item => {
            if (item.fieldType === 'franchiseName') {
              item.value = resp.data.franchisee.companyName
              this.$emit('setOldFranchiseeId', resp.data.franchisee.id)
              item.disabled = true
            } else if (item.fieldType === 'academicYear') {
              item.value = resp.data.franchiseeAcademicYear.academicYear
              item.disabled = true
            } else if (item.fieldType === 'class') {
              item.value = resp.data.studentClass.name
              item.disabled = true
            } else if (item.fieldType === 'section') {
              item.value = resp.data.studentSection.name
              item.disabled = true
            }
          })
          this.studentFieldArray.bottomBlock.forEach(item => {
            if (item.fieldType === 'studentName') {
              item.value = resp.data.studentEnrollment.studentName
              item.disabled = true
            } else if (item.fieldType === 'fatherName') {
              item.value = resp.data.studentEnrollment.fatherName
              item.disabled = true
            } else if (item.fieldType === 'motherName') {
              item.value = resp.data.studentEnrollment.motherName
              item.disabled = true
            } else if (item.fieldType === 'gaurdianName') {
              item.value = resp.data.studentEnrollment.guardianName
              item.disabled = true
            } else if (item.fieldType === 'studentDob') {
              item.value = this.formatDate(resp.data.studentEnrollment.dateOfBirth)
              item.disabled = true
            } else if (item.fieldType === 'fatherMob') {
              item.value = resp.data.studentEnrollment.fatherMobile
              item.disabled = true
            } else if (item.fieldType === 'motherMob') {
              item.value = resp.data.studentEnrollment.motherMobile
              item.disabled = true
            } else if (item.fieldType === 'gaurdianMob') {
              item.value = resp.data.studentEnrollment.guardianMobile
              item.disabled = true
            } else if (item.fieldType === 'studentGender') {
              item.value = resp.data.studentEnrollment.gender
              item.disabled = true
            } else if (item.fieldType === 'fatherEmail') {
              item.value = resp.data.studentEnrollment.fatherEmailID
              item.disabled = true
            } else if (item.fieldType === 'motherEmail') {
              item.value = resp.data.studentEnrollment.motherEmailID
              item.disabled = true
            } else if (item.fieldType === 'gaurdianEmail') {
              item.value = resp.data.studentEnrollment.guardianEmailID
              item.disabled = true
            } else if (item.fieldType === 'state') {
              item.value = resp.data.studentEnrollment.state
              item.disabled = true
            } else if (item.fieldType === 'city') {
              item.value = resp.data.studentEnrollment.city
              item.disabled = true
            } else if (item.fieldType === 'pincode') {
              item.value = resp.data.studentEnrollment.pincode
              item.disabled = true
            } else if (item.fieldType === 'address') {
              item.value = resp.data.studentEnrollment.address
              item.disabled = true
            }
          })
        } else {
          this.$emit('setStudentDetails', null)
        }
      } catch (e) {
        this.$emit('setStudentDetails', null)
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    getSelectedItem: function (item) {
      if (item.fieldType === 'studentKit') {
        this.$emit('setKitReceived', item.value)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
